'use client';
import Script from 'next/script';
import { usePathname } from 'next/navigation'; // ✅ NEW
import "@styles/globals.css";
import QueryProvider from "./QueryProvider";
import ReduxProvider from "./ReduxProvider";
import { GoogleAnalytics, GoogleTagManager } from "@next/third-parties/google";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import ExternalBrowser from "@components/redirect";
import TagManager from 'react-gtm-module';
import IntercomWidget from "@components/Intercom/intercom";
import { useUser } from "@hooks/Auth/useUser";
import { GoogleOAuthProvider } from '@react-oauth/google';
import config from "@config/config";
import Cookies from 'js-cookie';
import { storeFbclidFromUrl } from '@utils/fbclid';
import NextTopLoader from 'nextjs-toploader';
// const AdjustInitializer = dynamic(() => import("@hooks/useAdjust"), {
//   ssr: false,
// });

const gtmId = 'GTM-TCGVZNBP';
const GOOGLE_CLIENT_ID = config.GCLIENTID;

export default function RootLayout({ children }) {
  const [links, setLinks] = useState(null);
  const pathname = usePathname(); // ✅ NEW
  const { user } = useUser();

  useEffect(() => {
    
    if (typeof window !== "undefined") {
      setLinks(window.location);
    }
  }, []);

  useEffect(() => {
    TagManager.initialize({ gtmId });
  }, []);

  // ✅ Only activate Meta Pixel on the 2 specific event pages
  const shouldLoadMetaPixel =
    pathname === "/events/spozoULmJchgGjyNa659" ||
    pathname === "/events/MkyPmmulAAza5fTYjguc";
  console.log("shouldLoadMetaPixel", shouldLoadMetaPixel);
  const RECAPTCHA_SITE_KEY = config.RECAPTCHA_SITE_KEY;
 // ------------------------------------
 // sendBeacon “leave” on tab/window close
 useEffect(() => {
   const handleBeforeUnload = () => {
     const visitorId = Cookies.get('tickit-visitor-id');
     if (visitorId) {
       // hit the leave action so Redis ZREM’s this ID immediately
       navigator.sendBeacon(
         `/api/queue-status?client=${encodeURIComponent(visitorId)}&action=leave`
       );
     }
   };
   window.addEventListener('beforeunload', handleBeforeUnload);
   return () => {
     window.removeEventListener('beforeunload', handleBeforeUnload);
   };
 }, []);
 // ------------------------------------

   useEffect(() => {
    storeFbclidFromUrl();
  }, []);
  return (
    <html lang="en">
      <head>
        <script
          src={`https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`}
          async
          defer
        />
        <script src="https://wait.crowdhandler.com/js/latest/lite-validator/main.js?id=4cac9ecf0cd4caa8b61bd75b8e1be57bbc197c11217f5101873d70aa6c304ca6"></script>
        {/* <script
            type="text/javascript"
            src="//static.queue-it.net/script/queueclient.min.js"
          />
          <script
            type="text/javascript"
            data-queueit-c="tickit"
            src="//static.queue-it.net/script/queueconfigloader.min.js"
          />
          <script type='text/javascript' src='//static.queue-it.net/script/queueclient.min.js'></script>
<script
   data-queueit-c='tickit'
   type='text/javascript'
   src='//static.queue-it.net/script/queueconfigloader.min.js'>
</script> */}
      </head>
      <body>
        {/* GoogleOAuthProvider wraps all other providers to make OAuth context available globally */}
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <ReduxProvider>
            <QueryProvider>
              {/* <AdjustInitializer /> */}
              {links ? (
                <ExternalBrowser child={children} links={links}>
                          <NextTopLoader color="#29d" showSpinner={false} />

                  {children}
                </ExternalBrowser>
              ) : (
                children
              )}
              <noscript>
                <iframe
                  src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
                  height="0"
                  width="0"
                  style={{ display: "none", visibility: "hidden" }}
                ></iframe>
              </noscript>
              <IntercomWidget user={user} />
              <GoogleTagManager gtmId={gtmId} />
            </QueryProvider>
          </ReduxProvider>
        </GoogleOAuthProvider>
      </body>
    </html>
  );
}